import { useState } from "react";
import { ColorFormat, colorFormats } from "store/features/colorPicker/types";
import { useAppSelector } from "store/store";

export const useColorCodes = () => {
    const [selectedColorFormat, setSelectedColorFormat] = useState<ColorFormat>(colorFormats[1]);
    const source = useAppSelector((state) => state.colorPicker.source);
    return {
        selectedColorFormat,
        setSelectedColorFormat,
        source,
    };
};
